<template>
  <div>
      <header-inner/>
      <section class="news-section list__mod">
      <wrapper :line-center="true">
          <div class="title-main"><h1>Поиск: Новый управляющий директор</h1></div>
          <!-- Two related -->
          <section class="news">
            <card-news-small v-if="newsList" v-for="one in newsList"
                             :key="one.id"
                             :title="one.title"
                             :date="one.date"
                             :image="one.image"
                             :id="one.id"
                             :link="one.url"
            ><span v-html="one.text"></span>
            </card-news-small>
          </section>
      </wrapper>
    </section>
  </div>
</template>

<script>

    import HeaderInner from "../components/header/HeaderInner";
    import CardNewsSmall from "../components/shared/cards/CardNewsSmall";

    export default {

        name: "search",
        components: {HeaderInner, CardNewsSmall,},
        computed: {
          newsList() {
            return this.$store.state.content.entities.news.items;
          },
        },
        mounted() {
           this.$store.dispatch('content/loadEntities', { sID: 'news' });
        },
    }
</script>

<style lang="scss" scoped>
   .title-main {
       margin-top: 30px;
   }

</style>



// WEBPACK FOOTER //
// pages/search.vue